import { GlobalAxios } from "../axios/axios-config";

const BASE_URL = process.env.REACT_APP_IDENTIY;

export interface IUpdateUserPin {
  userId: string;
  newPin: string;
}

/**
 * Atualiza o PIN de um usuário (ação administrativa).
 * TODO: confirmar o caminho exato do endpoint com o backend.
 */
export const updateUserPin = ({ userId, newPin }: IUpdateUserPin) => {
  return GlobalAxios.post(`${BASE_URL}/api/v1/Users/ChangeUserPin`, {
    newPin,
    userId,
  });
};
